import { getFetch } from 'src/utils/fetcher';
import { concatQuerys, getPathWithQueries } from 'src/utils/url/url';
import { GET_UNALLOCATED_TASKS_KEY } from './getUnallocatedTasksAPI.constants';
import { TUnallocatedTasksRes } from './getUnallocatedTasksAPI.types';
import { ASSIGN_TAKE_ITEMS } from '../../constants';
import { useInfiniteList } from './useInfiniteList';

const GET_UNALLOCATED_TASKS_URL_PATH = '/api/v2/projects/{projectId}/tasks-unallocated';

interface IGetUnallocatedTasks {
  projectId: string;
  userId: string;
  isIncludeParentTask?: boolean;
  searchText?: string;
  take?: number;
  skip?: string;
}

const getUnallocatedTasks = ({
  isIncludeParentTask,
  projectId,
  searchText,
  userId,
  take = ASSIGN_TAKE_ITEMS,
  skip,
}: IGetUnallocatedTasks): Promise<TUnallocatedTasksRes> =>
  getFetch({
    path: `${getPathWithQueries(GET_UNALLOCATED_TASKS_URL_PATH.replace('{projectId}', projectId), {
      isIncludeParentTask,
      searchText: searchText?.trim(),
      userId,
    })}${concatQuerys(
      [
        { param: 'skip', value: skip },
        { param: 'take', value: String(take) },
      ],
      true,
    )}`,
    key: GET_UNALLOCATED_TASKS_KEY,
  });

export const useGetUnallocatedTasks = (params: IGetUnallocatedTasks, enableQuery?: boolean) => {
  const { isIncludeParentTask, projectId, searchText, userId } = params;

  return useInfiniteList({
    queryKey: [GET_UNALLOCATED_TASKS_KEY, isIncludeParentTask, projectId, searchText, userId],
    queryFn: async ({ pageParam = 0 }) => {
      const response = await getUnallocatedTasks({
        ...params,
        take: ASSIGN_TAKE_ITEMS,
        skip: String(pageParam * ASSIGN_TAKE_ITEMS),
      });

      return {
        items: response.entities ?? [], // Assuming response is an array of items
        nextSkip: (response.entities?.length ?? 0) < ASSIGN_TAKE_ITEMS ? null : pageParam + 1,
      };
    },
    take: ASSIGN_TAKE_ITEMS,
    enabled: enableQuery && !!projectId && !!userId,
  });
};
